import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Panel, Stat, Layout, LazyBoi, Amount, GateKeeper, Field } from '@components'
import { Asset } from '@archetypes'
import styled from 'styled-components'
import { RedeemController } from './_controller'
import appController, { Status } from '@app/App.Controller'
import { ReactComponent as Refresh } from '@assets/Icon_Refresh.svg';
import { roundDown , fromWei } from "@util/helpers"


const Wrapper = styled.div`
	

	.group-input {
		margin-bottom: 30px;
	}

`


const RedeemPartial = ({ address, setExtensions }) => {

    const { synthetics } = appController

    // approval params
    const [approvalStatus, setApprovalStatus] = useState()
    const [approvals, setApprovals] = useState()
    const [controller, setController] = useState()
    const [params, setParams] = useState()

    useEffect(() => {
        const redeemController = new RedeemController(address, appController)
        redeemController.on('approvals', setApprovals)
        redeemController.on('params', setParams)
        setController(redeemController)
        redeemController.init()
        return () => redeemController.cleanup()
    }, [address]) // eslint-disable-line

    useEffect(() => {
        if (params) {
            let payload = []  

            if (params?.myPosition?.tokensOutstanding) { 
                const newDebt = Number(fromWei(params?.myPosition?.collateral)) - params?.tokenAmount   
                payload.push({
                    key: "Total Debt",
                    value: <LazyBoi
                        value={newDebt}
                        suffix={params?.debtSymbol}
                        dp={2}
                    />
                })
            }

            if (params?.myPosition?.collateral) {
                const newTotalCollateral = Number(fromWei(params?.myPosition?.collateral)) - params?.value   
                payload.push({
                    key: "Total Collateral",
                    value: <LazyBoi
                        value={newTotalCollateral}
                        suffix={params?.symbol}
                        dp={2}
                    />
                })
            } 

            if (params?.myPosition?.actualCurrentRatio) {
                payload.push({
                    key: "New Collateral Ratio (CR)",
                    value: <LazyBoi
                        value={params?.myPosition?.actualCurrentRatio * 100}
                        suffix={"%"}
                        dp={0}
                    />
                })
            }


            setExtensions(payload)
        }
    }, [params])

    const maxAmount = useMemo(() => {
        if (params && params.max) {
            return `${roundDown(params.max, 2)}`
        } else {
            return "0"
        }
    }, [params]) // eslint-disable-line

    const onSubmit = useCallback(() => {
        if (Number(params?.value) > 0) {
            synthetics.redeem(params?.tx)
        }
    }, [params])

    return (
        <Panel fadeIn>
            <GateKeeper
                controllerAssertions={[
                    {
                        controller: 'account',
                        key: 'status',
                        assert: val => val === Status.READY,
                        onFail: <Panel fadeIn>Connect account to redeem your assets</Panel>,
                    },
                ]}
                assertions={[
                    {
                        assert: () => !!params,
                        onFail: () => <Panel fadeIn><Refresh className='rotate' />Fetching position information</Panel>,
                    },
                    {
                        assert: () => params?.userBalance !== "0",
                        onFail: () => <Panel fadeIn>No assets to redeem</Panel>,
                    }
                ]}
                dependencies={[params]}
            >
                <Wrapper>
                    <Amount.GroupSelect
                        className="group-input"
                        info="I WANT TO REDEEM"
                        infoEnd={`Max : ${Number(maxAmount).toLocaleString()} ${params?.debtSymbol}`}
                        min={0}
                        disabled={!controller}
                        onChange={val => controller?.updateInputAmount(val)}
                        max={params?.max}
                        selection={
                            <Asset.Icon
                                token={params?.debtSymbol}
                            />
                        }
                    />
                    <Amount.GroupSelect
                        className="group-input"
                        info="BY UNBLOCKING"
                        disabled={true}
                        value={params?.value}
                        selection={
                            <Asset.Icon
                                token={params?.symbol}
                            />
                        }
                    />
                    <Asset.ContractApproval.Wizard
                        approvals={approvals}
                        onUpdate={setApprovalStatus}
                        actionText={"Redeem assets"}
                        onAction={onSubmit}
                    />
                </Wrapper>
            </GateKeeper>
        </Panel>
    )
}

export default RedeemPartial
